import React from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import QuoteCardModal, { ShareQuoteData } from '../components/QuoteCardModal';

const SharingPage: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    // We receive the data from the location state
    const shareQuote = location.state?.shareQuote as ShareQuoteData;

    if (!shareQuote) {
        // If there's no data, redirect to library hub or previous page
        return <Navigate to="/library-hub" replace />;
    }

    return (
        <QuoteCardModal 
            data={shareQuote} 
            onClose={() => navigate(-1)} 
        />
    );
};

export default SharingPage;
